<mat-tab-group
  [style.width]="isExpanded() ? '100%' : '100%'"
  [(selectedIndex)]="activeIndex"
>
  <mat-tab *ngFor="let tab of tabs; let i = index" [label]="tab.header">
    <ng-template mat-tab-label
      >{{ tab.type }}{{ tab.header }}
      <mat-icon *ngIf="tab.isClosable" (click)="closeTab(i)">close</mat-icon>
    </ng-template>
    <div [ngSwitch]="tab.type">
      <p *ngSwitchCase="'Deliveribility'">
        <app-esptable
          [tabInformation]="{ tabType: tab.type, tabHeader: tab.header }"
          [requiredData]="{
            date1: tab.startDate,
            date2: tab.endDate,
            data: tab.data,
            teamId: tab.teamId,
            listId: tab.listId
          }"
          (AddTabController)="addTabInArray($event)"
        ></app-esptable>
      </p>
      <p *ngSwitchCase="'ESP_Accounts - '">
        <app-subesptable
          [tabInformation]="{ tabType: tab.type, tabHeader: tab.header }"
          [requiredData]="{
            date1: tab.startDate,
            date2: tab.endDate,
            data: tab.data,
            teamId: tab.teamId,
            listId: tab.listId
          }"
          (AddTabController)="addTabInArray($event)"
        ></app-subesptable>
      </p>
      <p *ngSwitchCase="'Teams - '">
        <app-teamtable
          [tabInformation]="{ tabType: tab.type, tabHeader: tab.header }"
          [requiredData]="{
            date1: tab.startDate,
            date2: tab.endDate,
            data: tab.data
          }"
          (AddTabController)="addTabInArray($event)"
        ></app-teamtable>
      </p>
      <p *ngSwitchCase="'Lists - '">
        <app-listtable
          [tabInformation]="{ tabType: tab.type, tabHeader: tab.header }"
          [requiredData]="{
            date1: tab.startDate,
            date2: tab.endDate,
            data: tab.data
          }"
          (AddTabController)="addTabInArray($event)"
        ></app-listtable>
      </p>
      <p *ngSwitchCase="'Segments - '">
        <app-segmenttable
          [tabInformation]="{ tabType: tab.type, tabHeader: tab.header }"
          [requiredData]="{
            date1: tab.startDate,
            date2: tab.endDate,
            data: tab.data
          }"
          (AddTabController)="addTabInArray($event)"
        ></app-segmenttable>
      </p>
      <p *ngSwitchCase="'Offers - '">
        <app-offertable
          [tabInformation]="{ tabType: tab.type, tabHeader: tab.header }"
          [requiredData]="{
            date1: tab.startDate,
            date2: tab.endDate,
            data: tab.data
          }"
          (AddTabController)="addTabInArray($event)"
        ></app-offertable>
      </p>
      <p *ngSwitchCase="'Campaigns - '">
        <app-campaigntable
          [tabInformation]="{ tabType: tab.type, tabHeader: tab.header }"
          [requiredData]="{
            date1: tab.startDate,
            date2: tab.endDate,
            data: tab.data
          }"
          (AddTabController)="addTabInArray($event)"
        ></app-campaigntable>
      </p>
      <p *ngSwitchCase="'Creatives - '">
        <app-creative-performance
          [tabInformation]="{ tabType: tab.type, tabHeader: tab.header }"
          [requiredData]="{
            date1: tab.startDate,
            date2: tab.endDate,
            data: tab.data
          }"
          (AddTabController)="addTabInArray($event)"
        ></app-creative-performance>
      </p>
      <p *ngSwitchCase="'Domains - '">
        <app-domaintable
          [tabInformation]="{ tabType: tab.type, tabHeader: tab.header }"
          [requiredData]="{
            date1: tab.startDate,
            date2: tab.endDate,
            data: tab.data
          }"
          (AddTabController)="addTabInArray($event)"
        ></app-domaintable>
      </p>
    </div>
  </mat-tab>
</mat-tab-group>
